import React from 'react'
import { FormControl, TextField } from '../../Atoms'
import PropTypes from 'prop-types'

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.any.isRequired,
  /** Placeholder for the component. **/
  label: PropTypes.any.isRequired,
  /** UX feature for browser to show relevant data on the field for easier completion of forms. **/
  autoComplete: PropTypes.any,
  /** Callback fired when the value is changed. **/
  onChange: PropTypes.func,
  /** The value of the Input element, required for a controlled component. **/
  value: PropTypes.string,
  /** Type attribute of the Input element. It should be a valid HTML5 input type. **/
  type: PropTypes.any,
  /** If true, the label will be displayed in an error state. **/
  error: PropTypes.bool,
  /**  The helper text content. **/
  helperText: PropTypes.node
}

const FormField = props => {
  if (!props.error) {
    props = { ...props, helperText: '' }
  }
  return (
    <FormControl margin='normal' fullWidth data-cid='FormField-root'>
      <TextField variant='outlined' {...props} />
    </FormControl>
  )
}

FormField.propTypes = propTypes

export default FormField
